import { useStaticQuery, graphql } from "gatsby"

const useEdlynProductQuery = () => {
  const { allDatoCmsEdlynProduct } = useStaticQuery(graphql`
    query Products {
      allDatoCmsEdlynProduct(
        filter: {hideForLocale: {ne: true}},
        sort: {position: ASC},
        limit: 150
      ) {
        nodes {
          id
          originalId
          title
          brand
          slug
          permalink
          header
          size
          category: edlynProductCategories {
            title
          }
          gallery {
            ...InternalAssetProps
          }
        }
      }
    }
  `)
  return allDatoCmsEdlynProduct.nodes
}

export default useEdlynProductQuery